import { render, staticRenderFns } from "./InsuranceDataList.vue?vue&type=template&id=651fae50&scoped=true"
import script from "./InsuranceDataList.vue?vue&type=script&lang=js"
export * from "./InsuranceDataList.vue?vue&type=script&lang=js"
import style0 from "./InsuranceDataList.vue?vue&type=style&index=0&id=651fae50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651fae50",
  null
  
)

export default component.exports